import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { storeUtils } from './util';
import { SlsActions } from '../actions/slsActions';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = 'change';

var _slsItems = [];
var _filteredItems = null;
var _areItemsLoading = false;
var _searchBy = "syncId";
var _slsItem = null;
let _resendItem = null;
let _resendPrintLata = "";

var dispatchToken = dispatcher.register(function (action) {
    switch (action.type) {
        case ActionTypes.LOAD_SLS_ITEMS_STARTED:
            _areItemsLoading = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.LOAD_SLS_ITEMS_DONE:
            _areItemsLoading = false;
            _slsItems = action.data;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.CHANGE_SLS_SEARCH_BY:
            _searchBy = action.value;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.FILTER_SLS_ITEMS:
            if (action.value) {
                var dataSet = _slsItems;
                switch (_searchBy) {
                    case "controlNumber": dataSet = dataSet.filter(function (item) {
                        if (item.controlNumber != null && ((item.controlNumber).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    case "subdivision": dataSet = dataSet.filter(function (item) {
                        if (item.subdivision != null && ((item.subdivision).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    case "pendingAction": dataSet = dataSet.filter(function (item) {
                        if (item.pendingAction != null && ((item.pendingAction).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    case "status": dataSet = dataSet.filter(function (item) {
                        if (item.status != null && ((item.status).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    case "tssReturnCode": dataSet = dataSet.filter(function (item) {
                        if (item.tssReturnCode != null && ((item.tssReturnCode).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    case "type": dataSet = dataSet.filter(function (item) {
                        if (item.type != null && ((item.type).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    case "lastModifiedTimeStamp": dataSet = dataSet.filter(function (item) {
                        if (item.lastModifiedTimeStamp != null && ((item.lastModifiedTimeStamp).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });
                        break;
                    default: dataSet = dataSet.filter(function (item) { //Default to searching by Sync ID
                        if (((item.syncId).toString().toUpperCase().indexOf(action.value.toString().toUpperCase()) !== -1)) {
                            return true
                        }
                    });

                }
                _filteredItems = dataSet;
            }
            else {
                _filteredItems = null;
            }
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.LOAD_SLS_ITEM_DONE:
            _slsItem = action.data;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.SLS_ITEM_UPDATE_SUCCESS:
            _slsItem = null;
            alert(`Item GR${action.data.syncId}, Id: ${action.data.id} saved successfully`);
            setTimeout(function () {
                SlsActions.loadSlsItems();
            }, 1);
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.SLS_ITEM_UPDATE_FAIL:
            alert(`Saving SLS failed, \nError: ${action.data}, \ncheck developer console for more details of the error.`);
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.SLS_ITEM_CLEAR:
            _slsItem = null;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.SLS_RESEND_SUCCESS:
            alert(`Item GR${action.data.syncId}, pending action ${(action.data.pendingAction)} resent successfully`);
            _resendItem = null;
            _slsItem = null;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.SLS_RESEND_FAIL:
            alert(`Resend failed, check developer console for error`);
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.LOAD_RESEND_ITEM:
            _resendItem = _slsItem;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.RESEND_ITEM_CLEAR:
            _resendItem = null;
            _events.trigger(CHANGE_EVENT);
            break;
        default:
        //no op
    }
});//end of dispatch token


//public api
export const slsStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    getItemsLoading: function () { return _areItemsLoading; },
    getSlsItems: function () { return _filteredItems || _slsItems; },
    getSlsItem: function () { return _slsItem },
    getResendItem: function () { return _resendItem },
    getResendPrintLata: function () { return _resendPrintLata },
    getSearchItemBy: function () { return _searchBy },
};
